import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ReactComponent as TogetherSvg } from '../../../../assets/icons/together.svg';

const { Title, Paragraph } = Typography;

const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10
  },
  title: {
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#404047",
    marginBottom: 20
  },
  subtitle: {
    fontWeight: "300",
    fontSize: "18px",
    lineHeight: "26px",
    display: "flex",
    alignItems: "center",
    textAlign: "center",
    color: "#8C8C8C",
    marginBottom: 30
  }
}

function MobileSignupRemainderScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const onBack = () => {
    history.push('/sign-up/guest')
  }

  const onSignUp = () => {
    history.push('/sign-up/guest/method')
  }

  const onSkip = () => {
    history.push('/sign-up/guest/thank-you')
  }

  return (
    <>
      <Row justify="center" style={{ padding: 0, marginBottom: 23 }}>
        <Col>
          <Button type="link" onClick={onBack}>
            <p style={styles.rowButton}>
              <ArrowLeftOutlined style={{ color: '#15A9E1' }} /> {t('sign-up:returnToPreviousPage')}
            </p>
          </Button>
        </Col>
      </Row>
      <Box display="flex" justifyContent="center">
        <TogetherSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box textAlign="center">
        <Row gutter={[0, 24]}>
          <Col xs={24}>
            <Title level={4} style={styles.title}>
              {t('sign-up:guest.signUpForAlemHealth')}
            </Title>
            <Paragraph style={styles.subtitle}>
              {t('sign-up:guest.signUpSubtitle')}
            </Paragraph>
            <Space direction="vertical" style={{ width: '100%' }}>
              <Button
                htmlType="button"
                type="primary"
                size="large"
                onClick={onSignUp}
                block
              >
                {t('sign-up:guest.yesSignMeUp')}
              </Button>
              <Box>
                <Divider plain><p style={styles.divider}>{t('sign-up:guest.notInterested')}</p></Divider>
              </Box>
              <Button
                htmlType="button"
                type="primary"
                size="large"
                onClick={onSkip}
                block
                ghost
              >
                {t('sign-up:skip')}
              </Button>
            </Space>
          </Col>
        </Row>
      </Box>
    </>
  );
}

export default MobileSignupRemainderScreen;
